export default function useFormSerializer(Serializer) {
  Serializer.addProperty('question', { category: 'general', name: 'id:text', readOnly: true });

  Serializer.addProperty('survey', {
    name: 'multipleSubmissions:switch',
    displayName: 'Allow Multiple Submissions',
    category: 'general',
  });
  Serializer.addProperty('survey', {
    name: 'submissionLimit:number',
    displayName: 'Submission Limit',
    maxValue: Number.MAX_SAFE_INTEGER,
    minValue: 1,
    default: 2,
    category: 'general',
    visibleIf: function (obj) {
      return obj ? obj.multipleSubmissions : false;
    },
  });
  Serializer.addProperty('survey', {
    name: 'submissionPrompt:text',
    displayName: 'New Submission Prompt Text',
    dependsOn: 'multipleSubmissions',
    default: 'New Attempt',
    category: 'general',
    visibleIf: function (obj) {
      return obj ? obj.multipleSubmissions : false;
    },
  });
  Serializer.addProperty('survey', {
    name: 'submissionPastResults',
    displayName: 'Show Past Results',
    type: 'boolean',
    default: false,
    category: 'general',
  });
  Serializer.addProperty('survey', {
    category: 'general',
    name: 'completionMessage',
    type: 'html',
    default: '<h3>Thank you for completing the survey!</h3>',
  });

  (Serializer.findProperty('survey', 'multipleSubmissions') || {}).visible = true;
  (Serializer.findProperty('survey', 'submissionLimit') || {}).visible = true;
  (Serializer.findProperty('survey', 'submissionPrompt') || {}).visible = true;
  (Serializer.findProperty('survey', 'submissionPastResults') || {}).visible = true;
  (Serializer.findProperty('survey', 'completionMessage') || {}).visible = true;

  Serializer.findProperty('question', 'visible').displayName = 'Show question'; // change "is visible?" to "show question"
  Serializer.findProperty('question', 'isRequired').displayName = 'Must answer'; // change "is required?" to "must answer"
}
